import { useRouter } from 'next/router'

export const useUpdateQueryParams = () => {
  const router = useRouter()

  const updateQueryParams = (query: Record<string, string | undefined>, resetScrollPosition = false) => {
    const [asPathRoot, asPathQuery = ''] = router.asPath.split('?')
    const params = new URLSearchParams(asPathQuery)

    Object.entries(query).forEach(([key, value]) => {
      if (value) {
        params.set(key, value)
      } else {
        params.delete(key)
      }
    })
    const asPath = `${asPathRoot}?${params.toString()}`
    router.push(asPath, asPath, { shallow: true })

    if (resetScrollPosition) {
      const obj = document.getElementById('mainContainer')
      if (obj) {
        obj.scrollTo({
          top: 0,
          behavior: 'smooth', // for smoothly scrolling
        })
      }
    }
  }

  return { updateQueryParams }
}
